<template>
  <div>
    <div>

    </div>
    <div>
      <v-card>
        <v-toolbar :color="ToolColor" dark @click="Hide = !Hide">
          <v-toolbar-title>
            {{ item.name }}
            <span class="cl">{{ ClassInfo.name }} </span></v-toolbar-title
          >
                    <v-toolbar-side-icon color="white darken-1">
            <v-icon v-if="Hide == false" color="orange ligthen-1"
              >arrow_downward</v-icon
            >
            <v-icon v-else color="orange ligthen-1">arrow_upward</v-icon>
              <v-icon color="orange ligthen-1"
              ></v-icon>
          </v-toolbar-side-icon>
      <v-flex justify="center" v-if="dialog">
        <Answers id="id" v-model="dialog" :Mapp="item" />
      </v-flex>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-expand-transition>
          <div v-if="Hide">
            <!-- {{done.split(' ').map(x => x[0].toUpperCase()).join('')}}  -->
            <div>
              <!--  v-if="item.hasOwnProperty('done')" -->
              <h3 @click="HideKlar = !HideKlar">
                Klara ({{ done.length }}/{{ classteachers.length }}):
              </h3>
              <div v-if="HideKlar != false">
                <v-btn
                  @mouseover="hoverDone = true"
                  @mouseleave="hoverDone = false"
                  v-for="done in done"
                  xs2
                  :key="done.updated"
                  outline
                  round
                  small
                  color="green"
                >
                  {{
                    hoverDone
                      ? locfun.getDate(done.updated)
                      : locfun.getName(done.name, teachernameandId, [])
                  }}
                </v-btn>
              </div>
            </div>
            <div>
              <!-- v-if="item.hasOwnProperty('ongoing')" -->

              <h3 @click="HidePågång = !HidePågång">
                Pågång({{ onGoing.length }}/{{ classteachers.length }}):
              </h3>
              <div v-if="HidePågång != false">
                <v-btn
                  v-for="done in onGoing"
                  xs2
                  :key="done.updated"
                  outline
                  round
                  small
                  @mouseover="hoverOngoing = true"
                  @mouseleave="hoverOngoing = false"
                  color="indigo"
                >
                  {{
                    hoverOngoing
                      ? locfun.getDate(done.updated)
                      : locfun.getName(done.name, teachernameandId, [])
                  }}
                </v-btn>
              </div>
            </div>
            <h3 @click="HideEjpåbörjad = !HideEjpåbörjad">
              Ej påbörjad({{ notStarted.length }}/{{ classteachers.length }}):
            </h3>
            <div v-if="HideEjpåbörjad != false">
              <v-btn
                v-for="done in notStarted"
                xs2
                :key="done"
                outline
                round
                small
                color="red"
              >
                {{ locfun.getName(done, teachernameandId, []) }}
              </v-btn>
            </div>
            <v-btn
              v-if="noAnswer == false"
              xs3
              class="mx-2"
              dark
              @click="dialog = true"
              color="green ligthen-4"
            >
              Se svar
            </v-btn>
          </div>
        </v-expand-transition>
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Answers from "./Answers";
import fun from "../functions";

export default {
  components: { Answers },

  props: {
    ToolColor: String,
    item: Object,
  },

  computed: {
    ...mapGetters("teachers", ["teachernameandId"]),
  },

  created() {
    this.locfun = new fun();
    this.getClass(this.item.class).then((res) => {
      this.ClassInfo = res;
      this.classteachers =this.ClassInfo.teacherIds.concat(this.ClassInfo.mentorIds) ;
  this.classteachers = [...new Set(  this.classteachers)];
     
      let onlynot = [];
      this.onGoing = [];
      this.done = [];
      this.notStarted = [];
      for (let i = 0; i < this.item.answer.length; i++) {
        if (this.classteachers.includes(this.item.answerId[i])) {
          if (this.item.answer[i].step == 1) {
            this.done.push({
              name: this.item.answerId[i],
              updated: this.item.answer[i].updated,
            });
          } else {
            this.onGoing.push({
              name: this.item.answerId[i],
              updated: this.item.answer[i].updated,
            });
          }
          onlynot.push(this.item.answerId[i]);
        }
      }
      this.notStarted = this.classteachers.filter(function (el) {
        return !onlynot.includes(el);
      });
    });
  
  },
  methods: {
    ...mapActions("classesAP", ["getClass"]),
  },
  data() {
    return {
      noAnswer: false,
      hoverOngoing: false,
      hoverDone: false,
      classteachers: [],
      ClassInfo: {},
      notStarted: [],
      done: [],
      onGoing: [],
      HideKlar: true,
      HidePågång: true,
      HideEjpåbörjad: true,
      Hide: false,
      dialog: false,
            TestMapp: { class: "az51edt2TsskvRE1FTUu", answerId: [ "dY3f0ELmaNktKpsI09r4", "dY3f0ELmaNktKpsI09r4", "dY3f0ELmaNktKpsI09r4", "dY3f0ELmaNktKpsI09r4", "dY3f0ELmaNktKpsI09r4" ], EHTId: "X5B6iT05dt4Awuig6kc1", answer: [
            
            { step: 1, answers: [ "Kaviar", "Trött", "1", "1", "2", "0", "1", "1", "0", "1", "3", "1", "0", "0", "1", "1", "1", "1","1","1", "1", "1","Han gillar röda pennor"], updated: 1628886650011 }, 
  { step: 1, answers: [ "hoo", "hej", "0", "0", "2", "0", "1", "1", "0", "0", "3", "1", "0", "0", "1", "1", "1", "1","1","1", "1", "1","Han gillar röda pennor"], updated: 1628886650011 }, 

//   { step: 1, answers: [ "Roligare elev finns inte i min värld!", "Han gillar röda pennor", "1", "0", "1", "0", "1", "1", "0", "1", "1", "1", "0", "0", "1", "1", "1", "1","Han gillar röda pennor"], updated: 1628886650011 },
// { step: 1, answers: [ "Trevlig kile, lite trött.","Han gillar röda pennor", "2", "1", "0", "0", "1", "1", "0", "1", "1", "1", "0", "0", "1", "1", "1", "1","Han gillar röda pennor"], updated: 1628886650011 },
// { step: 1, answers: [ "Vad är grejen med elever 2020?Vad är grejen med elever 2020?Vad är grejen med elever 2020?Vad är grejen med elever 2020?Vad är grejen med elever 2020?","Han gillar röda pennor", "1", "0", "1", "0", "1", "1", "0", "1", "1", "1", "0", "0", "1", "1", "1", "0","hejhej"], updated: 1628886650011 }, 
// { step: 1, answers: [ "Kaviar", "Trött", "1", "1", "2", "0", "1", "1", "0", "1", "3", "1", "0", "0", "1", "1", "1", "1","Han gillar röda pennor"], updated: 1628886650011 }, 
// { step: 1, answers: [ "Ostbågar", "Han gillar röda pennor", "1", "0", "1", "0", "1", "1", "1", "1", "1", "1", "0", "3", "1", "1", "1", "1","Han gillar röda pennor"], updated: 1628886650011 } 
], name: "Lance Alot", deadline: 1629763200000, schoolId: "aV0NTJr7VdWbN7I06aJfv3Piowf2", uploadDate: 1627511053156 },

    };
  },
};
</script>

<style>
.cl {
  color: orange !important;
  text-decoration: bold;
  background-color: white;
  border-radius: 50px;
  padding: 8px;
}
h3 {
  margin-left: 20px;
}
</style>